import { CSSProperties, Dispatch, Fragment, memo, ReactNode, SetStateAction, MouseEvent, forwardRef } from 'react';
import * as S from 'components/Modal/style';

import { Stack } from 'components/Stack';
import { Text } from 'components/Typography';
import { ReactComponent as IconClose } from 'constants/icon/ic_close_16.svg';
import { ReactComponent as SpinLoader } from 'constants/icon/ellipse_spin_loader.svg';
import { Card } from 'components/Card';
import { TS3 } from 'constants/types';
import styled from 'styled-components';

export interface ModalProps {
  isModalOpen?: boolean;
  setIsModalOpen?: Dispatch<SetStateAction<boolean>> | TS3<boolean>;
  children?: ReactNode;
  isLoadingModal?: boolean;
  loadingPlaceholder?: ReactNode | string;
  modalFooter?: ReactNode;
  padding?: number;
  width?: number;
  height?: string;
  zIndex?: number;
  closeCallbackFunc?: any;
  confirm?: { message: string | ReactNode; value: boolean; RBT?: string; LBT?: string };
  validateToClose?: Function;
  // header나 function 이 엮이지 않은 단순한 모달
  plain?: boolean;
  bd?: boolean;
  ds?: 'weak' | 'normal' | 'strong';
  modalHeigth?: string;
  //modal header 관련 부분
  title?: string; // modal header title
  ms?: number; //modal header와 children 사이 거리
  nomt?: boolean;
  sx?: CSSProperties;
  loadingModalsx?: CSSProperties;
  cardOnClick?: (event: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => void;
}

const AddModal = forwardRef<any, ModalProps>(
  (
    {
      closeCallbackFunc,
      isLoadingModal,
      loadingPlaceholder,
      modalFooter,
      plain,
      ds,
      ms,
      title,
      sx,
      isModalOpen = false,
      setIsModalOpen = () => {},
      padding = 0,
      width,
      height,
      children,
      validateToClose,
      confirm,
      nomt,
      loadingModalsx,
      modalHeigth,
      cardOnClick = () => {},

      ...props
    },
    cardRef
  ) => {
    return (
      <Fragment>
        {isModalOpen && (
          <S.Modal {...props}>
            <S.ScrollWrapper height={modalHeigth} nomt={nomt}>
              <Card variant={'menu'} sx={{ pointerEvents: 'auto', ...sx }} {...{ width, padding, ds }}>
                <Stack spacing={(ms as number) / 2 || 0} sx={{ height: '100%' }}>
                  <ModalBody style={{ paddingTop: (ms as number) / 2 || 0 }}>
                    {/* <Stack spacing={30}> */}
                    {children}
                    {/* </Stack> */}
                  </ModalBody>
                  {modalFooter && modalFooter}
                </Stack>
              </Card>
            </S.ScrollWrapper>
          </S.Modal>
        )}
      </Fragment>
    );
  }
);

export default memo(AddModal);

export const ModalBody = styled.div`
  width: 100%;
  flex: 1;
  ${({ theme }) => theme.modalScrollStyle.vertical};
  overflow-x: hidden;
`;
